import React from "react";
import { Modal } from "antd";

const ViewDetailsModal = (props) => {
  const { open, closeModal, details } = props;
  return (
    <>
      <Modal
        title={
          <h6 style={{ fontWeight: "bold" }}>Product Inventory Details</h6>
        }
        visible={open}
        footer={null}
        onCancel={closeModal}
        maskClosable={false}
        width={"550px"}
      >
        <div>
          <p>Product Name: {details?.name}</p>
          <p>Product Quantity: {details?.quantity}</p>
          {details?.raw_materials?.length > 0 && (
            <div>
              <h6
                style={{
                  borderBottom: "1px solid #F0F0F0",
                  paddingBottom: "0.5rem",
                }}
              >
                Raw Materials{" "}
              </h6>
              {details?.raw_materials?.map((option, index) => (
                <div
                  key={index}
                  style={{
                    borderBottom: "1px solid #F0F0F0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p>Raw Material: {option?.raw_material_name}</p>
                  <p>Quantity: {option?.quantity}</p>
                </div>
              ))}
            </div>
          )}
          {details?.expenses?.length > 0 && (
            <div style={{ marginTop: "1.5rem" }}>
              <h6
                style={{
                  borderBottom: "1px solid #F0F0F0",
                  paddingBottom: "0.5rem",
                }}
              >
                Expenses
              </h6>
              {details?.expenses?.map((option, index) => (
                <div
                  key={index}
                  style={{
                    borderBottom: "1px solid #F0F0F0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p>Name: {option?.name}</p>
                  <p>Cost: {option?.cost}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ViewDetailsModal;
